"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeData = exports.justData = exports.nothingData = void 0;
var plutus_data_1 = require("@harmoniclabs/plutus-data");
function nothingData() {
    return new plutus_data_1.DataConstr(1, []);
}
exports.nothingData = nothingData;
function justData(someData) {
    return new plutus_data_1.DataConstr(0, [someData]);
}
exports.justData = justData;
function maybeData(optionalData) {
    return optionalData === undefined ? nothingData() : justData(optionalData);
}
exports.maybeData = maybeData;
